import React from 'react';
import { Calendar } from 'primereact/calendar';
import moment from 'moment';
import { DATE_FORMAT } from '../../../constants/constants';
import './DatePicker.scss';

interface DatePickerWrapperProps {
	value: string;
	name: string;
	label: string;
	onChange: (dateString: string, name: string) => void;
	className?: string;
	isRequired?: boolean;
	errorMessage?: string;
	isDisabled?: boolean;
}

const DatePickerWrapper: React.FC<DatePickerWrapperProps> = ({
	value,
	name,
	label,
	onChange,
	className = '',
	isRequired = false,
	errorMessage = '',
	isDisabled = false,
}) => {
	const parseDate = (dateString: string): Date | null => (dateString ? moment(dateString, DATE_FORMAT).toDate() : null);

	const handleChange = (date: Date | null | undefined) => {
		if (!date) {
			onChange('', name);
			return;
		}
		const utcDate = moment(date).utc(true);
		onChange(utcDate.format(DATE_FORMAT), name);
	};

	const invalidClass = isRequired && value.trim().length === 0 ? 'invalid' : '';

	return (
		<div className={`pacer-datepicker ${invalidClass} ${className}`}>
			<div className='form-floating-wrapper'>

				<Calendar
					id={name}
					value={parseDate(value)}
					onChange={(e) => handleChange(e.value)}
					dateFormat='dd M yy'
					showIcon
					disabled={isDisabled}
				/>

				<label htmlFor={name} className='floating-label'>
					{label}
				</label>
			</div>
			{invalidClass && <div className='invalid-feedback'>{errorMessage}</div>}
		</div>
	);
};

export default DatePickerWrapper;
